import React from 'react'
import { useNavigate, useLocation } from 'react-router-dom';
import Logo from "../../assets/logo.png"

export default function Nav({ resetUpload, disableLogoClick }) {
  const navigate = useNavigate();
  const location = useLocation();

  function handleLogoClick() {
    if (disableLogoClick) return;

    if (location.pathname !== "/") navigate("/");
    else {
      resetUpload();
    }
  }

  return (
    <div className='absolute overflow-hidden h-full w-full top-0 pointer-events-none'>
      <div className='sticky h-14 w-full px-5 py-1 bg-offwhite flex justify-between items-center pointer-events-auto'>
        <div className='flex items-center gap-5 text-gray-900'>
          <div onClick={handleLogoClick} className='flex flex-row items-center me-2 cursor-pointer'>
            <img src={Logo} alt="logo" className='h-10 w-10' />
            <span className={`${location.pathname === "/" ? "font-extrabold" : "hover:font-medium active:scale-105"} ms-4 tracking-wider`}>Jellyo Uploads</span>
          </div>
          <div onClick={() => navigate("/my")} className={`${location.pathname === "/my" ? "font-semibold" : "hover:font-medium active:scale-105"} cursor-pointer select-none`}>My Uploads</div>
          {/* <div onClick={() => navigate("/browse")} className={`${location.pathname === "/browse" ? "font-semibold" : "hover:font-medium active:scale-105"} cursor-pointer select-none`}>Browse</div> */}
        </div>
        <div>
          {/* LOGIN */}
        </div>
      </div>
    </div>
  )
}
